import React from 'react';
import { Skeleton } from '@mui/material';

export const FAQListSkeleton = () => (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden max-w-full">
        {/* Mobile Skeleton */}
        <div className="block lg:hidden divide-y divide-gray-100 max-w-full overflow-hidden">
            {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="p-4">
                    <div className="flex items-start gap-3">
                        <Skeleton variant="rectangular" width={16} height={16} className="mt-1 flex-shrink-0" />
                        <div className="flex-1 min-w-0">
                            <Skeleton variant="text" width="90%" height={24} className="mb-2" />
                            <div className="flex gap-2 mb-2">
                                <Skeleton variant="rounded" width={60} height={20} />
                                <Skeleton variant="rounded" width={50} height={20} />
                            </div>
                            <div className="flex gap-2 mb-2">
                                <Skeleton variant="rounded" width={70} height={20} />
                            </div>
                            <div className="flex gap-4">
                                <Skeleton variant="text" width={60} height={16} />
                                <Skeleton variant="text" width={40} height={16} />
                                <Skeleton variant="text" width={40} height={16} />
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>

        {/* Desktop Skeleton */}
        <div className="hidden lg:block overflow-x-auto">
            <table className="w-full text-left">
                <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                        <th className="px-4 xl:px-6 py-3 w-12">
                            <Skeleton variant="rectangular" width={16} height={16} />
                        </th>
                        <th className="px-4 xl:px-6 py-3"><Skeleton variant="text" width={100} height={20} /></th>
                        <th className="px-4 xl:px-6 py-3"><Skeleton variant="text" width={60} height={20} /></th>
                        <th className="px-4 xl:px-6 py-3"><Skeleton variant="text" width={60} height={20} /></th>
                        <th className="px-4 xl:px-6 py-3"><Skeleton variant="text" width={80} height={20} /></th>
                        <th className="px-4 xl:px-6 py-3"><Skeleton variant="text" width={60} height={20} /></th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                        <tr key={i}>
                            <td className="px-4 xl:px-6 py-4">
                                <Skeleton variant="rectangular" width={16} height={16} />
                            </td>
                            <td className="px-4 xl:px-6 py-4">
                                <Skeleton variant="text" width="90%" height={24} />
                                <div className="flex gap-2 mt-1">
                                    <Skeleton variant="rounded" width={50} height={16} />
                                    <Skeleton variant="rounded" width={50} height={16} />
                                </div>
                            </td>
                            <td className="px-4 xl:px-6 py-4">
                                <Skeleton variant="rounded" width={70} height={24} />
                            </td>
                            <td className="px-4 xl:px-6 py-4">
                                <Skeleton variant="text" width={40} height={20} />
                            </td>
                            <td className="px-4 xl:px-6 py-4">
                                <div className="flex gap-3">
                                    <Skeleton variant="text" width={30} height={20} />
                                    <Skeleton variant="text" width={30} height={20} />
                                </div>
                            </td>
                            <td className="px-4 xl:px-6 py-4 text-right">
                                <div className="flex justify-end">
                                    <Skeleton variant="rounded" width={32} height={32} />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);
